"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrScheduleOpeningStatus = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const fdr_schedule_styles_1 = require("./fdr-schedule.styles");
function FdrScheduleOpeningStatus({ opened, showStatusIcon, className, }) {
    const [t] = (0, next_i18next_1.useTranslation)('agency');
    return (react_1.default.createElement(fdr_schedule_styles_1.FdrOpeningStatusWrapper, { "data-id": "fdr-help-overlay-opening-status", opened: opened, showStatusIcon: showStatusIcon, className: className }, t(opened ? 'agency:openingHours.opened' : 'agency:openingHours.closed')));
}
exports.FdrScheduleOpeningStatus = FdrScheduleOpeningStatus;
//# sourceMappingURL=fdr-schedule-opening-status.js.map